import { computed, inject, Injectable, signal } from '@angular/core';
import { FeaturedContent } from '../models/core/featured-content.model';
import { OrderType } from '../models/order-type.enum';
import { HttpClient } from '@angular/common/http';
import { map, Observable, tap } from 'rxjs';
import { FeaturedContentName } from '../models/core/featured-content-name.enum';
import { DeserializationUtils } from '../utils/deserialization-utils';

@Injectable({
  providedIn: 'root'
})
export class FeaturedContentService {
  private httpClient = inject(HttpClient);

  private _featuredContents = signal<FeaturedContent[]>([]);
  public featuredContents = computed<FeaturedContent[]>(() => this._featuredContents());

  // map keyed by keyName for direct access
  public featuredContentMap = computed(() => {
    const map: Record<string, FeaturedContent> = {};
    for (const item of this.featuredContents()) {
      if (item.keyName) {
        map[item.keyName] = item;
      }
    }
    return map;
  });

  public fetchFeaturedContents(orderType: OrderType, orderTime?: string): Observable<FeaturedContent[]> {
    let query = `orderType=${orderType.toString()}`;
    if (orderTime) {
      query += `&date=${encodeURIComponent(orderTime)}`;
    }
  
    return this.httpClient.get<any[]>(`/ws/integrated/v1/menu/featuredContent?${query}`).pipe(
      map(json => DeserializationUtils.deserializeArray(json, FeaturedContent)),
      tap(val => this.setFeaturedContents(val))
    );
  }

  getFeaturedContentsByAreaName(areaName: FeaturedContentName) {
    const newFeatureContent =  this.featuredContents().filter((featuredContent) => featuredContent.areaName === areaName)
   for (const content of newFeatureContent) {
  if (Array.isArray(content.featuredItems)) {
    for (const item of content.featuredItems) {
      if (typeof item.link === 'string') {
        const trimmed = item.link.trim();
        if (!/^https?:\/\//i.test(trimmed)) {
          item.link = `https://${trimmed}`;
        } else {
          item.link = trimmed; 
        }
      }
    }
  }
}
    return newFeatureContent
  }

  protected setFeaturedContents(val: FeaturedContent[]) {
    this._featuredContents.set(val);
  }
}
